export default "__VITE_ASSET__BbVxDOHh__"